export default __webpack_public_path__ + "static/media/Zeston-Dashboard1.d6ea3168.jpg";